<template>
  <div class="action-plan-page">
    <WeCircularNavbar />

    <section class="page-section hero-section">
      <div class="page-container">
        <h1 class="page-title">Action Plan</h1>

        <p class="page-intro">
          The Action Plans translate the project’s strategic objectives into concrete, region-specific actions,
          addressing key challenges and opportunities related to women-led enterprises, digitalisation, the circular
          economy and Smart Specialisation strategies.
        </p>

        <div class="cards-grid">
          <article class="info-card">
            <div class="info-card__header">Transnational Strategy</div>

            <div class="info-card__body">
              <p>
                The Transnational Strategy provides a shared vision and policy framework for strengthening women
                entrepreneurs’ role in the circular and digital transition across the Danube Region. It is based on the
                evidence, experiences and lessons learned throughout the WE.Circular project and aims to address the
                specific support needs of women-led businesses.
              </p>

              <a
                href="https://vali.hu/static/O_3_2TransnationalStrategyforWEsCircularTransition.pdf"
                target="_blank"
                rel="noopener noreferrer"
                class="download-btn"
              >
                <img :src="downloadIcon" alt="" />
              </a>
            </div>
          </article>
        </div>

        <div class="map-card" @click="goToRegionalPlans">
          <div class="map-card__top">
            <span class="map-card__label">Country specific regional action plans</span>
            <span class="map-card__arrow">→</span>
          </div>

          <div class="map-card__bottom"></div>
        </div>
      </div>
    </section>

    <WeCircularFooter />
  </div>
</template>

<script>
import WeCircularNavbar from './WeCircularNavbar.vue'
import WeCircularFooter from './WeCircularFooter.vue'
import downloadIcon from '../../assets/img/we-circular/download_1.svg'

export default {
  name: 'ActionPlanPage',
  components: {
    WeCircularNavbar,
    WeCircularFooter
  },
  data() {
    return {
      downloadIcon
    }
  },
  methods: {
    goToRegionalPlans() {
      this.$router.push({
        path: '/we-circular',
        hash: '#select-country'
      })
    }
  }
}
</script>

<style scoped>
.action-plan-page {
  min-height: 100vh;
  background: #f4f7f8;
}

.page-container {
  max-width: 1240px;
  margin: 0 auto;
  padding: 40px 32px 64px;
  box-sizing: border-box;
}

.page-title {
  margin: 0 0 16px;
  font-size: 42px;
  line-height: 1.12;
  font-weight: 700;
  color: #0f4c97;
  text-align: left;
}

.page-intro {
  max-width: 600px;
  margin: 0 0 40px;
  font-size: 18px;
  line-height: 1.7;
  color: #4f6f8f;
  text-align: left;
}

.cards-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  margin-bottom: 40px;
}

.info-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #7fa1ba;
  border-radius: 14px;
  background: #ffffff;
}

.info-card__header {
  padding: 16px 18px;
  background: linear-gradient(135deg, #0d5c5f 0%, #1e6d70 100%);
  color: #ffffff;
  font-size: 20px;
  line-height: 1.3;
  font-weight: 600;
  text-align: center;
}

.info-card__body {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  text-align: center;
}

.info-card__body p {
  margin: 0 0 24px;
  font-size: 16px;
  line-height: 1.7;
  color: #456987;
}

.download-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 8px;
  background: #0f4c97;
  transition: background 0.2s ease, transform 0.2s ease;
}

.download-btn:hover {
  background: #0c3d79;
  transform: translateY(-1px);
}

.download-btn img {
  width: 16px;
  height: 16px;
  object-fit: contain;
  display: block;
}

.map-card {
  display: flex;
  flex-direction: column;
  height: 170px;
  overflow: hidden;
  border: 2px solid #0a5b60;
  border-radius: 20px;
  background: #dfe8ea;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.map-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(12, 72, 78, 0.12);
}

.map-card__top {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  min-height: 78px;
  padding: 0 24px;
  background: linear-gradient(rgba(22, 108, 108, 0.82), rgba(22, 108, 108, 0.82)),
    url('../../assets/img/we-circular/map.png') center 20% / cover no-repeat;
}

.map-card__label {
  color: #ffffff;
  font-size: 18px;
  line-height: 1.2;
  font-weight: 500;
  text-align: center;
}

.map-card__arrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  border-radius: 50%;
  background: #0f4c97;
  color: #ffffff;
  font-size: 18px;
  line-height: 1;
}

.map-card__bottom {
  flex: 1;
  background: url('../../assets/img/we-circular/map.png') center 62% / cover no-repeat;
}

@media (max-width: 1024px) {
  .page-title {
    font-size: 34px;
  }

  .cards-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .page-container {
    padding: 30px 20px 48px;
  }

  .page-title {
    font-size: 30px;
  }

  .page-intro {
    font-size: 17px;
    line-height: 1.7;
  }

  .info-card__header {
    font-size: 18px;
  }

  .info-card__body {
    padding: 20px 18px;
  }

  .info-card__body p {
    font-size: 15px;
    line-height: 1.7;
  }

  .map-card {
    height: 156px;
    border-radius: 18px;
  }

  .map-card__top {
    min-height: 70px;
    padding: 0 18px;
  }

  .map-card__label {
    font-size: 16px;
  }

  .map-card__arrow {
    width: 26px;
    height: 26px;
    flex-basis: 26px;
    font-size: 16px;
  }
}
</style>
